import { ToastData } from '@/utils/types';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isScannerShow: false,
};

const scannerReaderSlice = createSlice({
	name: 'toastSlice',
	initialState,
	reducers: {
		showScanner(state) {
			return { ...state, isScannerShow: true };
		},
		hideScanner(state) {
			return { ...state, isScannerShow: false };
		},
	},
});

export const {  showScanner, hideScanner } = scannerReaderSlice.actions;
export default scannerReaderSlice;
